import { OVERLAY_CLASS } from './constants';

export function createOverlay() {
  const overlay = document.createElement('div');
  overlay.classList.add(OVERLAY_CLASS);
  return overlay;
}
